<template>
    <aside class="admin-sidebar">
        <div class="admin-sidebar__sections">
            <div
                v-for="section in sections"
                :key="section.key"
                class="menu-item"
            >
                <button
                    type="button"
                    class="icon-only"
                    :aria-label="section.title"
                    @click="openSection(section.key)"
                >
                    <span class="img">
                        <img :src="section.icon" alt="" />
                    </span>
                </button>
                <div class="button-hover">
                    <button type="button" @click="openSection(section.key)">
                        <span class="button-wrapper-img">
                            <span class="img">
                                <img :src="section.icon" alt="" />
                            </span>
                        </span>
                        <span class="txt">{{ section.title }}</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="menu-panel" :class="{ 'menu-panel--open': menuPanelOpen }">
            <div class="menu-panel__header">
                <div class="menu-panel__header-title">
                    {{ menuSectionTitle }}
                </div>
                <button
                    type="button"
                    class="menu-panel__close"
                    @click="$emit('close-menu-panel')"
                >
                    <span class="menu-panel__close-icon">×</span>
                </button>
            </div>

            <div class="menu-panel__content" @click="onMenuPanelClick">
                <div v-if="menuSection === 'main'" class="menu-panel__group">
                    <ul class="menu-panel__list">
                        <li>
                            <router-link
                                class="menu-panel__link"
                                :to="{ name: 'settings' }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/nastroyki.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.main_settings") }}
                                </span>
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                class="menu-panel__link"
                                :to="{ name: 'videoInstructions' }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/videoinstrukciya.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.video_instructions") }}
                                </span>
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                class="menu-panel__link"
                                :to="{ name: 'materials' }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/2-biblioteka-materialov.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.material_library") }}
                                </span>
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                class="menu-panel__link"
                                :to="{ name: 'faces' }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/19-portret.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.faces") }}
                                </span>
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                class="menu-panel__link"
                                :to="{ name: 'services' }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/3-dop-raboty.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.additional_work") }}
                                </span>
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                class="menu-panel__link"
                                :to="{ name: 'pages' }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/stranicy.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.pages") }}
                                </span>
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                class="menu-panel__link"
                                :to="{ name: 'updates' }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/admin-menu-obnovlenya.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    <span>Обновления</span>
                                    <span
                                        v-if="version?.need_update"
                                        class="menu-panel__alarm"
                                    >
                                        !
                                    </span>
                                </span>
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                class="menu-panel__link"
                                :to="{ name: 'licence' }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/4-licenziya-aktivna.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    <span v-if="license && license.name">
                                        {{ license.name }}
                                        <span
                                            v-if="
                                                license.type == 'standard' ||
                                                license.type == 'demo'
                                            "
                                            >[
                                            {{ license.day_remaining }} ]</span
                                        >
                                    </span>
                                    <span v-else>{{
                                        $t("admin.sidebar.license")
                                    }}</span>
                                </span>
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                class="menu-panel__link"
                                :to="{ name: 'about' }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/o-sisteme.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.about_system") }}
                                </span>
                            </router-link>
                        </li>
                    </ul>
                </div>

                <div
                    v-if="menuSection === 'landscape'"
                    class="menu-panel__group"
                >
                    <ul class="menu-panel__list">
                        <li>
                            <router-link
                                class="menu-panel__link"
                                :to="{ name: 'plots' }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/6-uchastok.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.plot") }}
                                </span>
                            </router-link>
                        </li>
                    </ul>
                </div>

                <div v-if="menuSection === 'catalog'" class="menu-panel__group">
                    <ul class="menu-panel__list">
                        <li>
                            <a
                                :href="`/${settings.admin_path}/elements/stely`"
                                class="menu-panel__link"
                                :class="{
                                    'router-link-exact-active router-link-active':
                                        $route.params.slug == 'stely',
                                }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/7-stely.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.stely") }}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                :href="`/${settings.admin_path}/elements/tumby`"
                                class="menu-panel__link"
                                :class="{
                                    'router-link-exact-active router-link-active':
                                        $route.params.slug == 'tumby',
                                }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/8-tumba.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.thumbs") }}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                :href="`/${settings.admin_path}/elements/cvetniki-nadgrobiya`"
                                class="menu-panel__link"
                                :class="{
                                    'router-link-exact-active router-link-active':
                                        $route.params.slug ==
                                        'cvetniki-nadgrobiya',
                                }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/9-cvetnik.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.cvetniki") }}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                :href="`/${settings.admin_path}/elements/vazy`"
                                class="menu-panel__link"
                                :class="{
                                    'router-link-exact-active router-link-active':
                                        $route.params.slug == 'vazy',
                                }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/11-vazy.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.vaze") }}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                :href="`/${settings.admin_path}/elements/stoliki`"
                                class="menu-panel__link"
                                :class="{
                                    'router-link-exact-active router-link-active':
                                        $route.params.slug == 'stoliki',
                                }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/stoliki.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.tables") }}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                :href="`/${settings.admin_path}/elements/skameiki`"
                                class="menu-panel__link"
                                :class="{
                                    'router-link-exact-active router-link-active':
                                        $route.params.slug == 'skameiki',
                                }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/skameyki.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.skameiki") }}
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>

                <div
                    v-if="menuSection === 'barriers'"
                    class="menu-panel__group"
                >
                    <ul class="menu-panel__list">
                        <li>
                            <a
                                :href="`/${settings.admin_path}/barriers`"
                                class="menu-panel__link"
                                :class="{
                                    'router-link-exact-active router-link-active':
                                        [
                                            'barriers',
                                            'add_barrier',
                                            'edit_barrier',
                                        ].includes($route.name),
                                }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/10-ogrady.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.barriers") }}
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>

                <div
                    v-if="menuSection === 'landscaping'"
                    class="menu-panel__group"
                >
                    <ul class="menu-panel__list">
                        <li>
                            <a
                                :href="`/${settings.admin_path}/landscaping/plate-fill`"
                                class="menu-panel__link"
                                :class="{
                                    'router-link-exact-active router-link-active':
                                        $route.params.slug == 'plate-fill',
                                }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/13-osnovanie.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.plita_fill") }}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                :href="`/${settings.admin_path}/landscaping/stripe`"
                                class="menu-panel__link"
                                :class="{
                                    'router-link-exact-active router-link-active':
                                        $route.params.slug == 'stripe',
                                }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/polosa.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.stripe") }}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                :href="`/${settings.admin_path}/landscaping/plate-ready`"
                                class="menu-panel__link"
                                :class="{
                                    'router-link-exact-active router-link-active':
                                        $route.params.slug == 'plate-ready',
                                }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/plita-gotovaya.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.plita_ready") }}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                :href="`/${settings.admin_path}/landscaping/facing`"
                                class="menu-panel__link"
                                :class="{
                                    'router-link-exact-active router-link-active':
                                        $route.params.slug == 'facing',
                                }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/oblicovka.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.facing") }}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                :href="`/${settings.admin_path}/landscaping/paving`"
                                class="menu-panel__link"
                                :class="{
                                    'router-link-exact-active router-link-active':
                                        $route.params.slug == 'paving',
                                }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/15-plitka.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.moshenie") }}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                :href="`/${settings.admin_path}/landscaping/pour`"
                                class="menu-panel__link"
                                :class="{
                                    'router-link-exact-active router-link-active':
                                        $route.params.slug == 'pour',
                                }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/14-otsypka.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.otsipka") }}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                :href="`/${settings.admin_path}/landscaping/grass`"
                                class="menu-panel__link"
                                :class="{
                                    'router-link-exact-active router-link-active':
                                        $route.params.slug == 'grass',
                                }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/17-gazon.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.gazon") }}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                :href="`/${settings.admin_path}/landscaping/border`"
                                class="menu-panel__link"
                                :class="{
                                    'router-link-exact-active router-link-active':
                                        $route.params.slug == 'border',
                                }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/16-bordyur.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.border") }}
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>

                <div v-if="menuSection === 'design'" class="menu-panel__group">
                    <ul class="menu-panel__list">
                        <li>
                            <router-link
                                class="menu-panel__link"
                                :to="{ name: 'engraving-text' }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/18-text.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.text") }}
                                </span>
                            </router-link>
                        </li>
                        <li>
                            <a
                                :href="`/${settings.admin_path}/engravings/portraits`"
                                class="menu-panel__link"
                                :class="{
                                    'router-link-exact-active router-link-active':
                                        $route.params.slug == 'portraits',
                                }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/19-portret.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.portrait") }}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                :href="`/${settings.admin_path}/engravings/christianstvo`"
                                class="menu-panel__link"
                                :class="{
                                    'router-link-exact-active router-link-active':
                                        $route.params.slug == 'christianstvo',
                                }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/20-hristianstvo.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.christ") }}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                :href="`/${settings.admin_path}/engravings/islam`"
                                class="menu-panel__link"
                                :class="{
                                    'router-link-exact-active router-link-active':
                                        $route.params.slug == 'islam',
                                }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/21-musulmanstvo.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.islam") }}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                :href="`/${settings.admin_path}/engravings/other`"
                                class="menu-panel__link"
                                :class="{
                                    'router-link-exact-active router-link-active':
                                        $route.params.slug == 'other',
                                }"
                            >
                                <span class="menu-panel__item-icon">
                                    <img
                                        src="/images/icons/menu/22-prochee.svg"
                                        alt=""
                                    />
                                </span>
                                <span class="menu-panel__item-text">
                                    {{ $t("admin.sidebar.others") }}
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </aside>
</template>
<script>
export default {
    name: "Sidebar",
    props: {
        menuPanelOpen: {
            type: Boolean,
            default: false,
        },
        menuSection: {
            type: String,
            default: null,
        },
    },
    emits: ["open-menu-section", "close-menu-panel"],
    computed: {
        license() {
            return this.$store.state.license;
        },
        version() {
            return this.$store.state.versions.version;
        },
        settings() {
            return this.$store.state.settings.settings;
        },
        activeSectionKey() {
            const routeName =
                this.$route && this.$route.name ? this.$route.name : null;

            if (
                routeName === "home" ||
                routeName === "orders" ||
                routeName === "order_detail"
            ) {
                return null;
            }

            const mainRoutes = new Set([
                "settings",
                "videoInstructions",
                "materials",
                "add_material",
                "edit_material",
                "faces",
                "services",
                "pages",
                "updates",
                "licence",
                "about",
            ]);

            if (routeName && mainRoutes.has(routeName)) {
                return "main";
            }

            const landscapeRoutes = new Set(["plots"]);

            if (routeName && landscapeRoutes.has(routeName)) {
                return "landscape";
            }

            const catalogRoutes = new Set([
                "elements",
                "add_element",
                "edit_element",
                "elements_types",
                "add_element_type",
                "edit_element_type",
            ]);

            if (routeName && catalogRoutes.has(routeName)) {
                return "catalog";
            }

            const barriersRoutes = new Set([
                "barriers",
                "add_barrier",
                "edit_barrier",
            ]);

            if (routeName && barriersRoutes.has(routeName)) {
                return "barriers";
            }

            const landscapingRoutes = new Set([
                "landscapings",
                "add_landscaping",
                "edit_landscaping",
                "landscaping_types",
                "add_landscaping_type",
                "edit_landscaping_type",
            ]);

            if (routeName && landscapingRoutes.has(routeName)) {
                return "landscaping";
            }

            const designRoutes = new Set([
                "appearance",
                "engraving-text",
                "engravings",
                "engravings_types",
                "add_engraving_type",
                "edit_engraving_type",
            ]);

            if (routeName && designRoutes.has(routeName)) {
                return "design";
            }

            return null;
        },
        sections() {
            const isActive = (key) => this.activeSectionKey === key;

            return [
                {
                    key: "main",
                    title: this.$t("admin.sidebar.main_params"),
                    icon: isActive("main")
                        ? "/images/admin-ui/sections/admin-osnovnye-parametry-aktiv.svg"
                        : "/images/admin-ui/sections/admin-osnovnye-parametry.svg",
                },
                {
                    key: "landscape",
                    title: this.$t("admin.sidebar.landscape"),
                    icon: isActive("landscape")
                        ? "/images/admin-ui/sections/admin-landshaft-aktiv.svg"
                        : "/images/admin-ui/sections/admin-landshaft.svg",
                },
                {
                    key: "catalog",
                    title: this.$t("admin.sidebar.elements_catalog"),
                    icon: isActive("catalog")
                        ? "/images/admin-ui/sections/admin-katalog-elementov-aktiv.svg"
                        : "/images/admin-ui/sections/admin-katalog-elementov.svg",
                },
                {
                    key: "barriers",
                    title: this.$t("admin.sidebar.barriers"),
                    icon: isActive("barriers")
                        ? "/images/admin-ui/sections/admin-ogrady-aktiv.svg"
                        : "/images/admin-ui/sections/admin-ogrady.svg",
                },
                {
                    key: "landscaping",
                    title: this.$t("admin.sidebar.landscaping"),
                    icon: isActive("landscaping")
                        ? "/images/admin-ui/sections/admin-blagoustroystvo-aktiv.svg"
                        : "/images/admin-ui/sections/admin-blagoustroystvo.svg",
                },
                {
                    key: "design",
                    title: this.$t("admin.sidebar.design"),
                    icon: isActive("design")
                        ? "/images/admin-ui/sections/admin-oformlenie-aktiv.svg"
                        : "/images/admin-ui/sections/admin-oformlenie.svg",
                },
            ];
        },
        menuSectionTitle() {
            const found = this.sections.find((s) => s.key === this.menuSection);
            return found ? found.title : "";
        },
    },
    methods: {
        openSection(key) {
            if (this.menuPanelOpen && this.menuSection === key) {
                this.$emit("close-menu-panel");
                return;
            }
            this.$emit("open-menu-section", key);
        },
        onMenuPanelClick(event) {
            const target = event?.target;
            if (!(target instanceof Element)) return;

            const link = target.closest(".menu-panel__link");
            if (!link) return;

            this.$emit("close-menu-panel");
        },
    },
};
</script>

<style scoped>
.admin-sidebar {
    color: #fff;
    display: flex;
    flex-direction: column;
    position: fixed;
    left: 0;
    top: 55px;
    width: 55px;
    height: calc(100vh - 55px);
    padding: 0;
    background-color: #232435;
    z-index: 101;
}
.admin-sidebar__sections {
    padding: 10px 0;
}
.menu-item {
    position: relative;
    padding: 0 5px;
}
.menu-item + .menu-item::before {
    content: "";
    position: absolute;
    top: 0;
    left: 5px;
    right: 5px;
    height: 1px;
    background: rgba(207, 226, 232, 0.18);
    z-index: 3;
    pointer-events: none;
}

.icon-only {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 64px;
    padding: 0;
    background: transparent;
    border: none;
    box-sizing: border-box;
    cursor: pointer;
}
.menu-item:hover .icon-only {
    background-color: rgba(255, 255, 255, 0.06);
    border-radius: 6px;
}
.icon-only:focus {
    outline: none;
}
.img {
    width: 40px;
    height: 40px;
    display: inline-block;
}
.img img {
    max-width: 100%;
    max-height: 100%;
}
.button-hover {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}
.button-hover button {
    display: none;
    align-items: center;
    width: 240px;
    height: 64px;
    background-color: #232435;
    border: none;
    box-shadow: 0 10px 26px rgba(0, 0, 0, 0.35);
    border-radius: 0 6px 6px 0;
    padding: 0 14px 0 0;
    cursor: pointer;
}
.button-hover button:focus {
    outline: none;
}
.button-wrapper-img {
    width: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 55px;
}
.txt {
    white-space: nowrap;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
}
.menu-item:hover .button-hover button {
    display: flex;
}
.menu-panel {
    position: fixed;
    top: 0;
    left: 0;
    width: 280px;
    height: 100vh;
    background-color: #232435;
    border-right: 1px solid rgba(207, 226, 232, 0.18);
    transform: translateX(-100%);
    transition: transform 180ms ease;
    z-index: 110;
    pointer-events: none;
}
.menu-panel--open {
    transform: translateX(0);
    pointer-events: auto;
}
.menu-panel__header {
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 73px 0 18px;
    position: relative;
}
.menu-panel__header-title {
    text-transform: uppercase;
    color: #bec0ca;
    font-weight: 700;
    font-size: 14px;
    letter-spacing: 0.04em;
}
.menu-panel__close {
    position: absolute;
    top: 0;
    right: 0;
    width: 55px;
    height: 55px;
    background-color: #223644;
    border: none;
    display: grid;
    place-content: center;
    cursor: pointer;
    transition: transform 180ms ease, background-color 180ms ease;
}
.menu-panel--open .menu-panel__close {
    transform: translateX(55px);
}
.menu-panel__close:hover {
    background-color: #232435;
}
.menu-panel__close:focus {
    outline: none;
}
.menu-panel__close-icon {
    display: none;
}
.menu-panel__close::before,
.menu-panel__close::after {
    content: "";
    width: 32px;
    height: 1px;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform-origin: center;
}
.menu-panel__close::before {
    transform: translate(-50%, -50%) rotate(45deg);
}
.menu-panel__close::after {
    transform: translate(-50%, -50%) rotate(-45deg);
}
.menu-panel__content {
    padding: 10px 10px;
    overflow-y: auto;
    height: calc(100% - 55px);
}
.menu-panel__list {
    list-style: none;
    padding: 0;
    margin: 0;
}
.menu-panel__list li + li {
    margin-top: 4px;
}
.menu-panel__link {
    width: 100%;
    color: #fff;
    text-decoration: none;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 6px;
}
.menu-panel__link:hover {
    background-color: rgba(255, 255, 255, 0.08);
}
.menu-panel__link.router-link-exact-active,
.menu-panel__link.router-link-active {
    background-color: rgba(255, 255, 255, 0.12);
    font-weight: 700;
}
.menu-panel__item-icon {
    width: 26px;
    height: 26px;
    display: grid;
    place-content: center;
    flex: 0 0 auto;
}
.menu-panel__item-icon img {
    max-width: 100%;
    max-height: 100%;
    opacity: 0.9;
}
.menu-panel__item-text {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}
.menu-panel__alarm {
    border-radius: 999px;
    background-color: #ff0000;
    width: 18px;
    height: 18px;
    font-size: 12px;
    display: grid;
    place-content: center;
    font-weight: 700;
}
</style>
